module.exports = __webpack_public_path__ + "img/lingdongliang@2x.a2fb717f.png";